import React from 'react';
import './Vision.css';

// 텍스트를 마침표 기준으로 줄바꿈하는 함수
const formatText = (text) => {
  return text.split('. ').map((sentence, index, array) => (
    <React.Fragment key={index}>
      {sentence}{index < array.length - 1 ? '.' : ''}
      {index < array.length - 1 && <br />}
    </React.Fragment>
  ));
};

function Vision() {
  return (
    <div className="vision-page vision-page--studio">
      <section className="vision-page-hero">
        <div className="vision-page-hero__inner">
          <p className="vision-page-hero__label">STAR612 STUDIO</p>
          <h1>Our Vision</h1>
          <p>아이디어를 영상으로, 제작 방식을 시스템으로 — AI 영상 스튜디오의 방향을 소개합니다.</p>
        </div>
      </section>
      <div className="vision-container">
        <h2 className="vision-intro">
          <span className="highlight">AI 영상</span>과 <span className="highlight">시스템</span>으로 제작의 새 지평을 열다
        </h2>
        <div className="vision-separator"></div>
        <p className="vision-description">
          {formatText("작은별612는 AI 영상 제작·솔루션 구축·개발 역량을 하나로 연결합니다. 크리에이터와 기업이 아이디어를 빠르게 영상으로 구현하고, 자체 제작 파이프라인까지 운영할 수 있는 미래를 만듭니다.")}
        </p>
        
        <div className="vision-section">
          <div className="vision-image">
            <img src={process.env.PUBLIC_URL + "/images/innovative-ai.jpg"} alt="혁신적인 Ai 경험" />
          </div>
          <div className="vision-content">
            <div className="vision-title">
              <img src={process.env.PUBLIC_URL + "/images/icons8-electronics-52.png"} alt="아이콘" className="vision-icon" />
              <h3>AI 영상 제작 스튜디오</h3>
            </div>
            <p>
              {formatText("storyboard.ai.kr을 플래그십으로, 콘티 기반 AI 워크플로우로 숏폼부터 브랜드 필름까지 빠르게 제작합니다. 결과물이 곧 신뢰가 되는 구조를 지향합니다.")}
            </p>
          </div>
        </div>

        <div className="vision-section">
          <div className="vision-image">
            <img src={process.env.PUBLIC_URL + "/images/personalized-learning.jpg"} alt="개인화된 학습 여정" />
          </div>
          <div className="vision-content">
            <div className="vision-title">
              <img src={process.env.PUBLIC_URL + "/images/icons8-electronics-52.png"} alt="아이콘" className="vision-icon" />
              <h3>기업 맞춤 제작 솔루션</h3>
            </div>
            <p>
              {formatText("기업·기관에 자체 AI 영상 제작 파이프라인과 작업공간을 설계·구축합니다. 워크플로우·시스템·교육까지 한 번에 연결합니다.")}
            </p>
          </div>
        </div>

        <div className="vision-section">
          <div className="vision-image">
            <img src={process.env.PUBLIC_URL + "/images/global-communication.jpg"} alt="글로벌 커뮤니케이션의 미래" />
          </div>
          <div className="vision-content">
            <div className="vision-title">
              <img src={process.env.PUBLIC_URL + "/images/icons8-electronics-52.png"} alt="아이콘" className="vision-icon" />
              <h3>개발로 증명하는 기술력</h3>
            </div>
            <p>
              {formatText("10년 이상의 웹·앱·플랫폼 개발 역량으로 storyboard, 제우스(trading), LottyRobot 등 자체 서비스를 직접 기획·개발·운영합니다.")}
            </p>
          </div>
        </div>

        <div className="vision-section">
          <div className="vision-image">
            <img src={process.env.PUBLIC_URL + "/images/global-avatar.jpg"} alt="AR-AR을 통합한 환경" />
          </div>
          <div className="vision-content">
            <div className="vision-title">
              <img src={process.env.PUBLIC_URL + "/images/icons8-electronics-52.png"} alt="아이콘" className="vision-icon" />
              <h3>3D·AI 언어학습 (레거시 R&D)</h3>
            </div>
            <p>
              {formatText("3D 캐릭터·언어학습 제품은 레거시 R&D로 계속 발전시키며, 메인 사업은 AI 영상 스튜디오로 집중합니다. 이전 제품은 /legacy/product에서 확인할 수 있습니다.")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vision;